import React,{useState} from "react" 
import './App.css'

const App = () => {


  const [phone, setPhone] = useState("");

  return(
   <> 



   <div className="row" style={{margin: "0"}}>
   <div className="col-12" style={{paddingLeft: "0", paddingRight   : "0"}}>
   <p id="text1">NoSave WhatsApp</p>   
   </div>
   </div> 
   
   <div className="row" style={{margin: "0"}}>
       <div className="col-12" style={{paddingLeft: "0", paddingRight   : "0"}}>
         <div className="line"></div>
       </div>
     </div>   

    
   <div className="row" style={{margin: "0"}}>
   <div className="col-lg-8 section1">
   <img src="bg4.gif" 
   width="100%"
   height="100%"
   alt="bg"/>
   
   </div>    

   <div className="col-lg-4 section2">
    <p id="text2">Sending WhatsApp messages</p> 
    <p id="text3">Just one time</p>  
    <p id="text3">Is</p> 
    <p id="text3">Now not a pain...</p>
    <p id="text6">Send messages without saving number in your contact</p>
  
<br/>

   
   <div> 
   <input 
   placeholder="Ex: 910123456789"
   className="form-control"
   id="mobilenumber"
   value={phone}
   onChange= {(e) => { setPhone(e.target.value) } } 
   type="text"/> 
  <span className="text-light">*with country code</span>

      <br/><br/>
   </div>
   <button
   className="btn btn-block btn-primary" onClick={()=>{window.open(`https://api.whatsapp.com/send?phone=${phone}&text=&source=&data=&app_absent=`)}} >Proceed
   </button>
   <br/>
   
   </div>
   </div>
    
   
   
   
   
   
   
   
   
    </>
   )
} 

export default App;